import { Data, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { reaction } from 'mobx';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';
import UpdateCorporateActionEventCommand from '../Models/Commands/UpdateCorporateActionEventCommand';
import CorporateActionEventLookup from '../Models/Lookups/CorporateActionEventLookup';
import CorporateActionEventSearchCriteria from '../Models/Queries/CorporateActionEventSearchCriteria';
import ManageCorporateActionEventComponentVM from '../Components/ManageCorporateActionEventComponentVM';
import CompleteCorporateActionEventCommand from '../Models/Commands/CompleteCorporateActionEventCommand';
import CompleteCorporateActionEventComponentVM from '../Components/CompleteCorporateActionEventComponentVM';

export default class CorporateActionEventsVM extends Views.ViewModelBase {
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public corporateActionEventsApiClient = AppService.get(Types.ApiClients.CorporateActionEventsApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {

        super(taskRunner);
        this.makeObservable();
    }
    
    public corporateActionEventSearchCriteria = new CorporateActionEventSearchCriteria();
    public showManageCorporateActionComponent: boolean = false;
    public manageCorporateActionEventVM = new ManageCorporateActionEventComponentVM();
    public completeCorporateActionEventVM = new CompleteCorporateActionEventComponentVM();
    public showDeleteConfirmModalInd: boolean = false;
    public showCompleteConfirmModalInd: boolean = false;
    public corporateActionToDelete: CorporateActionEventLookup = new CorporateActionEventLookup();
    public completedCorporateActionsStatus: string = "ReviewSuccessful";

    public pageManager = new Data.PageManager(this.corporateActionEventSearchCriteria, CorporateActionEventLookup, this.corporateActionEventsApiClient.getCorporateActionEventsPagedList, {
        pageSize: 10,
        sortAscending: false,
        fetchInitial: true,
        initialTaskRunner: this.taskRunner,
    });

    public async initialise() {
        reaction(() => this.corporateActionEventSearchCriteria.searchCriteria, () => this.pageManager.refreshData(), {fireImmediately: false, delay: 650 });
    }

    public cancel() {
        this.manageCorporateActionEventVM.managedCorporateActionEvent = new CorporateActionEventLookup()
        this.showManageCorporateActionComponent = false;
    }

    public async clearSearch() {
        this.corporateActionEventSearchCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public editCorporateActionEvent(corporateActionEventLookup : CorporateActionEventLookup) {
        this.showManageCorporateActionComponent = true;
        this.manageCorporateActionEventVM.managedCorporateActionEvent.mapFrom(corporateActionEventLookup).toJSObject();
    }

    public showDeleteCorporateActionModal(corporateActionEventLookup : CorporateActionEventLookup){
        this.manageCorporateActionEventVM.managedCorporateActionEvent.mapFrom(corporateActionEventLookup).toJSObject();
        this.showDeleteConfirmModalInd = true;
    }

    public showCompleteCorporateActionModal(completeCorporateActionEventLookup : CorporateActionEventLookup){
        this.completeCorporateActionEventVM.completeCorporateActionEvent.mapFrom(completeCorporateActionEventLookup).toJSObject();
        this.showCompleteConfirmModalInd = true;
    }

    public completeCorporateActionEvent() { 
        this.completeCorporateActionEventVM.completeCorporateActionEvent.isCompleted = true;
        this.showCompleteConfirmModalInd = false;
        this.handleCompleteSave();
    }    

    public deleteCorporateActionEvent() {        
        this.manageCorporateActionEventVM.managedCorporateActionEvent.isDeleted = true;
        this.showDeleteConfirmModalInd = false;
        this.handleSave();
    }

    public async save() {
        this.handleSave()
        this.showManageCorporateActionComponent = false;
        this.manageCorporateActionEventVM.managedCorporateActionEvent = new CorporateActionEventLookup();
    }

    private handleSave(){
        this.taskRunner.run(async () => {
            var response = await this.corporateActionEventsApiClient.updateCorporateActionEvent(this.mapCorporateActionEventToUpdateCommand()!.toJSObject());

            if (response.data.success) {
                await this.pageManager.refreshData();
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.CorporateActionEventSaved, NotificationDuration.Standard);
            }
            else {
                NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
            }
        });
    }

    private mapCorporateActionEventToUpdateCommand() {
        var command = new UpdateCorporateActionEventCommand().mapFrom(this.manageCorporateActionEventVM.managedCorporateActionEvent);
        return command;
    }

    private handleCompleteSave(){
        this.taskRunner.run(async () => {
            var response = await this.corporateActionEventsApiClient.completeCorporateActionEvent(this.mapCorporateActionEventToCompleteCommand()!.toJSObject());

            if (response.data.success) {
                await this.pageManager.refreshData();
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.CorporateActionEventSaved, NotificationDuration.Standard);
            }
            else {
                NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
            }
        });
    }

    private mapCorporateActionEventToCompleteCommand() {
        var command = new CompleteCorporateActionEventCommand().mapFrom(this.completeCorporateActionEventVM.completeCorporateActionEvent);
        return command;
    }
}